import { useSelector } from 'react-redux'

const useZone = () => {
  return useSelector((state: any) => state.zone)
}

export default useZone
